<!-- クライアント側PDF生成用ページ（サーバー側処理以降のため未使用） -->
<template>
  <div class="">
    <div class="pdf" id="pdfContents">
      <div class="pdf-top">
        <div class="pdf-top-left">
          <div class="pdf-top-name">名前</div>
          <div class="pdf-top-emptiness"></div>
          <div class="pdf-top-name">様</div>
        </div>
        <div class="pdf-top-right">
          <div class="pdf-top-right-item">{{ subjectId }}</div>
          <div class="pdf-top-right-item">{{ genderText }}</div>
          <div class="pdf-top-right-item">{{ age }}歳</div>
        </div>
      </div>
      <div class="border-image"></div>

      <div class="pdf-title"></div>
      <div style="display: flex; align-items: center">
        <img src="@/assets/img/pdf-title-strong.png" style="width: 144.37px; height: 26.4px" />
        <img src="@/assets/img/pdf-title.png" style="width: 232.23px; height: 26.43px; margin-left: 14px" />
      </div>

      <div class="pdf-explanation">
        <span class="pdf-explanation-storong" style="padding-bottom: 1px">
          <span style="position: relative; z-index: 1">舌や唇の動き</span>
          <span class="underLine"></span>
        </span>
        の
        <span class="pdf-explanation-storong" style="padding-bottom: 1px">
          <span style="position: relative; z-index: 1">速度・リズム</span>
          <span class="underLine"></span>
        </span>
        を評価します
        <span class="pdf-explanation-storong" style="padding-bottom: 1px">
          <span style="position: relative; z-index: 1"> 滑舌</span>
          <span class="underLine"></span>
        </span>
        に加えて、
        <span class="pdf-explanation-storong" style="padding-bottom: 1px">
          <span style="position: relative; z-index: 1">咀嚼・嚥下</span>
          <span class="underLine"></span>
        </span>
        にも重要な機能です。
      </div>
      <div class="pdf-main">
        <img src="@/assets/img/woman-report.png" style="position: absolute; right: 16px; top: -103px; width: 98px; height: 130px" />
        <div class="measure-result-list">
          <div v-for="measure in measurements" :key="measure.type" :class="['measure-result-item', 'measure-result-item--pdf', `measure-result-item--${measure.type}`]" :id="[`pdfContents-${measure.type}`]" style="max-height: 380px">
            <div class="measure-result-item-audio"></div>
            <div class="measure-result-item-top">
              <div class="measure-result-item-title">{{ getGraphText(measure.type)[0] }}</div>
              <div class="measure-result-item-explanation">{{ getGraphText(measure.type)[1] }}</div>
            </div>
            <div class="measure-result-item-main">
              <div class="top-wrap">
                <div class="measure-result-item-img"></div>
                <div class="num-wrap">
                  <div class="num-area" v-if="vocabPerSeconds[measure.type] !== 0">
                    <div class="num-area-explanation">あなたの発音回数</div>
                    <div class="num-area-text-wrap">
                      <div class="num-area-text" :style="{ fontSize: getFontSize(vocabPerSeconds[measure.type]) }">{{ vocabPerSeconds[measure.type] }}</div>
                      <div class="num-area-unit">回/秒</div>
                    </div>
                  </div>
                  <div class="num-area-notmeasure" v-else>未実施</div>
                  <div class="num-explanation">合格ラインは6.0回/秒以上</div>
                </div>
              </div>

              <div class="bottom-wrap">
                <div class="bottom-title">1秒毎の発音回数の推移</div>
                <div class="measure-result-item--pdf measure-result-item-graph" style="position: relative">
                  <img src="@/assets/img/pdf-graph-img.png" />
                  <div style="position: absolute; top: -40px">
                    <canvas :ref="`graphCanvas-${measure.type}`" :id="`graphCanvas-${measure.type}`" height="200"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pdf-bottom">
        <div class="pdf-bottom-date">{{ inspectionTime(endDateTime) }}</div>
        <div class="pdf-bottom-copyright" style="margin-right: 70px">© 2025 Lion Corporation. All rights reserved.</div>
        <img src="@/assets/img/logo.png" style="width: 51px; height: auto" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import { formatPDFTime } from './common/dateFormatter';
import Chart from 'chart.js/auto';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  setup() {
    const store = useStore();
    const subjectId = ref(store.getters['dataManagement/getSubjectId']);
    const gender = ref(store.getters['dataManagement/getGender']);
    const age = ref(store.getters['dataManagement/getAge']);
    const measurements = ref(store.getters['dataManagement/getMeasurements']);
    const endDateTime = ref(store.getters['dataManagement/getEndDateTime']);
    const genderText = ref(gender.value === 1 ? '男性' : gender.value === 2 ? '女性' : gender.value === 3 ? 'その他' : '');

    // グラフパラメータの初期化
    const canvas = ref(null);
    const canvasCtx = ref(null);
    const graphData = ref(store.getters['dataManagement/getGraphData']);
    const vocabPerSeconds = ref({});

    // コンポーネントがマウントされたときにデータを取得
    onMounted(async () => {
      const graphParams = setGraphParams();
      await setChart(graphParams);
      // DOMの更新を待つ
      await nextTick();
      // 画面更新にウェイトを設けてPDF化する
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const pdfBlob = await convertToPDF();
      await setPDFToS3(pdfBlob);
      // PDFを生成しS3への保管後にPDFを開く
      getPDF(pdfBlob);
    });

    // グラフで使用する文言を取得
    function getGraphText(measureWord) {
      switch (measureWord) {
        case 'pa':
          return ['口唇の動き', '食べこぼしの防止や咀嚼に重要'];
        case 'ta':
          return ['舌の前方の動き', '食べ物のすり潰しや飲み込みに重要'];
        case 'ka':
          return ['舌の後方の動き', '食べ物を飲み込み食道に運ぶために重要'];
        default:
          return [];
      }
    }

    // 桁数に応じたフォントサイズを取得する関数
    function getFontSize(vocabPerSecond) {
      return vocabPerSecond >= 10 ? '22px' : '30px';
    }

    // 日時をフォーマットする関数
    const inspectionTime = (dateTime) => {
      return formatPDFTime(dateTime);
    };

    // チャートを設定する処理
    const setChart = async (graphParams) => {
      try {
        // 各測定に対して非同期で処理を実行
        const promises = measurements.value.map(async (measure) => {
          return new Promise((resolve) => {
            // グラフの表示キャンバスを取得
            const canvasId = `graphCanvas-${measure.type}`;
            canvas.value = document.getElementById(canvasId);
            canvasCtx.value = canvas.value.getContext('2d');

            // 測定が実施済みの場合
            if (measure.status === '実施済み') {
              const data = getChartData(graphParams[measure.type]);
              const options = getChartOptions();

              // Chartオブジェクトを生成して表示
              const lineChart = new Chart(canvasCtx.value, {
                type: 'line',
                data: data,
                options: options,
              });
              lineChart.update();
              resolve();
            } else {
              // 測定が未実施の場合もresolve
              resolve();
            }
          });
        });

        // 全ての非同期処理が完了するまで待機
        await Promise.all(promises);
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('チャートの設定中にエラーが発生しました:', error);
      }
    };

    // グラフのパラメータを設定する処理
    const setGraphParams = () => {
      try {
        // グラフパラメータを初期化
        const graphParams = {};

        // グラフデータから各種パラメータを取得
        graphData.value.forEach((item) => {
          const type = item.type || '';
          vocabPerSeconds.value[type] = item.vocabPerSecond !== null ? Number(item.vocabPerSecond).toFixed(1) : 0;

          // グラフパラメータが存在しない場合は初期化
          if (!graphParams[type]) {
            graphParams[type] = {
              times: [],
              vocabRatesPerSecond: [],
              threshold: 6,
              measureWord: type,
            };
          }
          // グラフデータを設定
          graphParams[type].times = item.vocabCountSecond || [];
          graphParams[type].vocabRatesPerSecond = item.vocabCountSecond || [];
        });

        return graphParams;
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('グラフパラメータの設定中にエラーが発生しました:', error);
        return {};
      }
    };

    // チャートデータの取得
    function getChartData(graphParam) {
      const { times, vocabRatesPerSecond, threshold, measureWord } = graphParam;
      const [mainColor, subColor] = getGraphColor(measureWord);

      // 発音回数グラフのデータを取得
      const pronunciationDataset = {
        data: vocabRatesPerSecond,
        borderColor: mainColor,
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: (context) => (context.parsed.y >= threshold ? mainColor : subColor),
        pointBorderColor: (context) => (context.parsed.y >= threshold ? subColor : mainColor),
      };
      return { labels: times, datasets: [pronunciationDataset] };
    }

    // グラフで使用する色を取得
    function getGraphColor(measureWord) {
      switch (measureWord) {
        case 'pa':
          return ['#dc6e6e', '#ffffff']; // 赤
        case 'ta':
          return ['#56af78', '#ffffff']; // 緑
        case 'ka':
          return ['#1550a3', '#ffffff']; // 青
        default:
          return ['#002850', '#ffffff']; // デフォルト: 黒
      }
    }

    // チャートオプションの取得
    function getChartOptions() {
      const padding = {
        top: canvas.value.offsetWidth * 0.106,
        left: canvas.value.offsetWidth * 0.06,
        right: canvas.value.offsetWidth * 0.305,
        bottom: canvas.value.offsetWidth * 0.082,
      };

      return {
        animation: false,
        scales: {
          x: { min: 0, max: 11, display: false },
          y: { min: 0, max: 10, display: false },
        },
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        layout: { padding },
      };
    }

    // webページをPDFとして取得
    const convertToPDF = async () => {
      // PDFContents要素のサイズを取得
      window.resizeTo(window.screen.availWidth, window.screen.availHeight);
      const pdfContentsElement = document.getElementById('pdfContents');
      const pdfContentsWidth = pdfContentsElement.offsetWidth;
      const pdfContentsHeight = pdfContentsElement.offsetHeight;

      // A4キャンバスサイズの寸法
      const a4Width = 1033;
      const a4Height = 1462;

      // A4サイズのマージンの設定
      const a4WidthLandscape = 210;
      const a4HeightLandscape = 297;
      const marginRate = 0.2;
      const aspectRatio = a4WidthLandscape / a4HeightLandscape;
      const widthMargin = a4WidthLandscape * marginRate;
      const heightMargin = widthMargin * aspectRatio;

      // キャンバスのサイズを調整
      const scaleFactor = Math.min(a4Width / pdfContentsWidth, a4Height / pdfContentsHeight);
      const scaledWidth = pdfContentsWidth * scaleFactor;
      const scaledHeight = pdfContentsHeight * scaleFactor;

      // A4サイズに合わせてjsPDFインスタンスを作成
      const pdf = new jsPDF('l', 'pt', 'a4');

      // 現在のウェブページの内容をキャプチャ
      const canvas = await html2canvas(pdfContentsElement, { width: scaledWidth + widthMargin, height: scaledHeight + heightMargin });
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', (widthMargin / 2) * aspectRatio, (heightMargin / 2) * aspectRatio, scaledWidth, scaledHeight);

      // Blobを取得
      const pdfBlob = pdf.output('blob');

      return pdfBlob;
    };

    // PDFデータをS3へ保管
    const setPDFToS3 = async (pdfBlob) => {
      try {
        const inspectionId = store.getters[`dataManagement/getInspectionId`];
        const inspectionPDFURL = store.getters['dataManagement/getInspectionPDFURL'];

        // Blob を ArrayBuffer に変換
        const arrayBuffer = await pdfBlob.arrayBuffer();
        // ArrayBuffer から Uint8Array を生成
        const uint8Array = new Uint8Array(arrayBuffer);
        // Base64 エンコード
        const base64Data = uint8ArrayToBase64(uint8Array);

        const paramsS3 = {
          Bucket: 'pataka.storedata',
          Key: `pataka_data/pdf_data/${inspectionPDFURL}`,
          Body: base64Data,
          ContentType: 'text/plain',
        };

        // PDFデータをS3にアップロード
        await store.dispatch('measurePDF/uploadS3', paramsS3);

        // S3の配置先を取得
        const updateData = {
          pdfURL: paramsS3.Key,
          inspectionId: inspectionId,
        };

        // 検査結果の登録
        await store.dispatch('measurePDF/update', updateData);
      } catch (error) {
        console.error('検査結果保存中にエラーが発生しました:', error);
      }
    };

    // Uint8Array を Base64 エンコードする関数
    function uint8ArrayToBase64(uint8Array) {
      let binary = '';
      uint8Array.forEach((byte) => {
        binary += String.fromCharCode(byte);
      });
      return btoa(binary);
    }

    // PDFリンクを生成しダウンロード
    const getPDF = (blob) => {
      const pdfUrl = store.getters['dataManagement/getInspectionPDFURL'];
      // Blob から URL を生成
      const pdfBlobUrl = URL.createObjectURL(blob);

      // ダウンロードリンクを生成
      const downloadLink = document.createElement('a');
      downloadLink.href = pdfBlobUrl;
      // ファイル名の部分を抽出
      const fileName = pdfUrl.split('/').pop();
      downloadLink.download = fileName;

      // ダウンロードリンクをクリック
      downloadLink.click();
      // Blob URL を開放
      URL.revokeObjectURL(pdfBlobUrl);
    };

    return {
      subjectId,
      gender,
      age,
      measurements,
      endDateTime,

      genderText,
      vocabPerSeconds,
      inspectionTime,
      getGraphText,
      getFontSize,
      convertToPDF,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';
@import '@/scss/project/_pdf.scss';

.measure-result-item {
  margin-bottom: 28px;
}

.measure-result-item-explanation {
  width: max-content;
}

.num-area-notmeasure {
  width: 114px;
  height: 68px;
  font-size: 20px;
  border-radius: 8px;
  font-family: 'NotoSans-Bold';
  background-color: #f0efef;
  color: #002850;
  display: flex;
  align-items: center;
  justify-content: center;
}

.underLine {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #fedc50;
  z-index: 0;
}
</style>